var _defs, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoachingSessionBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bg-2",
    "data-name": "bg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 713,
    height: 370,
    viewBox: "0 0 713 370",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.914,
    x2: 1,
    y2: 0.086,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8e5bda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ad6be0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb7ae6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.914,
    x2: 1,
    y2: 0.086,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.914,
    x2: 1,
    y2: 0.086,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c7d9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c6ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 713,
    height: 370,
    rx: 30,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 0.236,
    x2: 0.5,
    y2: 0.919,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#aeaeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 0.018,
    y2: 0.895,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: -0.188,
    y2: 0.873,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: -0.085,
    y2: 0.884,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 0.18,
    y2: 0.913,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 0.138,
    y2: 0.908,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: -0.046,
    y2: 0.889,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    y1: -0.296,
    y2: 0.862,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    y1: -0.116,
    y2: 0.881,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    y1: -0.339,
    y2: 0.857,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 0.096,
    y2: 0.904,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    y1: -0.24,
    y2: 0.868,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    y1: 0.039,
    y2: 0.898,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    y1: 0.123,
    y2: 0.907,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    y1: -0.014,
    y2: 0.892,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    y1: 0.315,
    y2: 0.927,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 0.5,
    y1: -0.103,
    x2: 0.5,
    y2: 1.344,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 0.5,
    y1: 0.081,
    x2: 0.5,
    y2: 1.286,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 0.5,
    y1: -0.533,
    x2: 0.5,
    y2: 1.477,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 0.5,
    y1: -0.746,
    x2: 0.5,
    y2: 1.544,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 0.5,
    y1: 0.036,
    x2: 0.5,
    y2: 1.3,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0.5,
    y1: 0.255,
    x2: 0.5,
    y2: 1.232,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 0.5,
    y1: -0.839,
    x2: 0.5,
    y2: 1.573,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 0.5,
    y1: 0.234,
    x2: 0.5,
    y2: 1.239,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 0.5,
    y1: -0.379,
    x2: 0.5,
    y2: 1.43,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 0.5,
    y1: -1.058,
    x2: 0.5,
    y2: 1.641,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 0.5,
    y1: -0.189,
    x2: 0.5,
    y2: 1.37,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 0.5,
    y1: -0.061,
    x2: 0.5,
    y2: 1.33,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 0.5,
    y1: -1.207,
    x2: 0.5,
    y2: 1.687,
    xlinkHref: "#linear-gradient-34"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg-3",
    "data-name": "bg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-4",
    "data-name": "bg",
    width: 713,
    height: 370,
    rx: 30,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bg-5",
    "data-name": "bg",
    width: 713,
    height: 370,
    rx: 30,
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clip",
    clipPath: "url(#clipPath)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13132",
    "data-name": "Group 13132",
    transform: "translate(36.165 -94.755)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13129",
    "data-name": "Group 13129",
    transform: "translate(-41.157 48.298)",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13127",
    "data-name": "Group 13127",
    transform: "translate(8.141)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 21.964,
    height: 430.208,
    transform: "translate(0 49.249)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    width: 21.964,
    height: 334.463,
    transform: "translate(26.129 144.994)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 21.964,
    height: 276.498,
    transform: "translate(52.258 202.959)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_778",
    "data-name": "Rectangle 778",
    width: 21.964,
    height: 302.686,
    transform: "translate(78.386 176.771)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    "data-name": "Rectangle 779",
    width: 21.963,
    height: 400.746,
    transform: "translate(104.515 78.71)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_780",
    "data-name": "Rectangle 780",
    width: 21.964,
    height: 334.463,
    transform: "translate(130.644 144.994)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_781",
    "data-name": "Rectangle 781",
    width: 21.965,
    height: 381.253,
    transform: "translate(156.772 98.204)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_782",
    "data-name": "Rectangle 782",
    width: 21.964,
    height: 314.146,
    transform: "translate(182.902 165.311)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 21.964,
    height: 253.585,
    transform: "translate(209.03 225.872)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    width: 21.963,
    height: 294.502,
    transform: "translate(235.159 184.955)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    "data-name": "Rectangle 785",
    width: 21.963,
    height: 245.398,
    transform: "translate(261.288 234.059)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    width: 21.964,
    height: 314.146,
    transform: "translate(287.416 165.311)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    width: 21.964,
    height: 334.463,
    transform: "translate(313.545 144.994)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_788",
    "data-name": "Rectangle 788",
    width: 21.964,
    height: 276.498,
    transform: "translate(339.673 202.959)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_789",
    "data-name": "Rectangle 789",
    width: 21.964,
    height: 334.463,
    transform: "translate(365.802 144.994)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_790",
    "data-name": "Rectangle 790",
    width: 21.963,
    height: 363.248,
    transform: "translate(391.932 116.209)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_791",
    "data-name": "Rectangle 791",
    width: 21.963,
    height: 314.146,
    transform: "translate(418.06 165.311)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_792",
    "data-name": "Rectangle 792",
    width: 21.963,
    height: 265.04,
    transform: "translate(444.188 214.417)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_793",
    "data-name": "Rectangle 793",
    width: 21.963,
    height: 245.398,
    transform: "translate(470.317 234.059)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_794",
    "data-name": "Rectangle 794",
    width: 21.962,
    height: 302.686,
    transform: "translate(496.445 176.771)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_795",
    "data-name": "Rectangle 795",
    width: 21.963,
    height: 363.248,
    transform: "translate(522.572 116.209)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_796",
    "data-name": "Rectangle 796",
    width: 21.963,
    height: 381.253,
    transform: "translate(548.701 98.204)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_797",
    "data-name": "Rectangle 797",
    width: 21.962,
    height: 341.97,
    transform: "translate(574.831 137.487)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_798",
    "data-name": "Rectangle 798",
    width: 21.963,
    height: 374.703,
    transform: "translate(600.958 104.753)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_799",
    "data-name": "Rectangle 799",
    width: 21.963,
    height: 265.04,
    transform: "translate(627.087 214.417)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_800",
    "data-name": "Rectangle 800",
    width: 21.962,
    height: 323.966,
    transform: "translate(653.215 155.491)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_801",
    "data-name": "Rectangle 801",
    width: 21.962,
    height: 363.248,
    transform: "translate(679.344 116.209)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_802",
    "data-name": "Rectangle 802",
    width: 21.963,
    height: 302.686,
    transform: "translate(705.471 176.771)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_803",
    "data-name": "Rectangle 803",
    width: 21.963,
    height: 374.703,
    transform: "translate(731.6 104.753)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_804",
    "data-name": "Rectangle 804",
    width: 21.962,
    height: 479.457,
    transform: "translate(757.729)",
    fill: "url(#linear-gradient-33)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13128",
    "data-name": "Group 13128",
    transform: "translate(0 224.185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_805",
    "data-name": "Rectangle 805",
    width: 42.906,
    height: 172.448,
    transform: "translate(0 82.824)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_806",
    "data-name": "Rectangle 806",
    width: 42.905,
    height: 206.96,
    transform: "translate(52.559 48.312)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_807",
    "data-name": "Rectangle 807",
    width: 42.905,
    height: 124.133,
    transform: "translate(105.118 131.138)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_808",
    "data-name": "Rectangle 808",
    width: 42.906,
    height: 108.948,
    transform: "translate(157.677 146.324)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_809",
    "data-name": "Rectangle 809",
    width: 42.905,
    height: 197.293,
    transform: "translate(210.236 57.979)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_810",
    "data-name": "Rectangle 810",
    width: 42.906,
    height: 255.272,
    transform: "translate(262.794)",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_811",
    "data-name": "Rectangle 811",
    width: 42.906,
    height: 103.478,
    transform: "translate(315.353 151.794)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_812",
    "data-name": "Rectangle 812",
    width: 42.905,
    height: 172.448,
    transform: "translate(367.912 82.824)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_813",
    "data-name": "Rectangle 813",
    width: 42.907,
    height: 248.367,
    transform: "translate(420.47 6.905)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_814",
    "data-name": "Rectangle 814",
    width: 42.903,
    height: 137.937,
    transform: "translate(473.031 117.334)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_815",
    "data-name": "Rectangle 815",
    width: 42.906,
    height: 197.293,
    transform: "translate(525.588 57.979)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_816",
    "data-name": "Rectangle 816",
    width: 42.906,
    height: 92.437,
    transform: "translate(578.147 162.835)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_817",
    "data-name": "Rectangle 817",
    width: 42.905,
    height: 160.026,
    transform: "translate(630.706 95.245)",
    fill: "url(#linear-gradient-46)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_818",
    "data-name": "Rectangle 818",
    width: 42.906,
    height: 206.96,
    transform: "translate(683.264 48.312)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_819",
    "data-name": "Rectangle 819",
    width: 42.905,
    height: 179.35,
    transform: "translate(735.824 75.922)",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_820",
    "data-name": "Rectangle 820",
    width: 42.905,
    height: 86.226,
    transform: "translate(788.383 169.046)",
    fill: "url(#linear-gradient-49)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13130",
    "data-name": "Group 13130",
    transform: "translate(187.809 17.382)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M836.46,413.406h5.574V360.641h.557v52.766h5.572v54.706h-5.572v26.243h-.557V468.112H836.46Z",
    transform: "translate(-84.112 -45.461)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M821.3,403.9h.557V437.6h5.572v14.922h-5.572v85.093H821.3V452.525h-5.575V437.6H821.3Z",
    transform: "translate(-82.048 -49.768)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M800.572,366.316h.557v72.523H806.7v4.97h-5.571v29.429h-.557V443.809H795v-4.97h5.571Z",
    transform: "translate(-79.984 -46.026)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M779.839,393.773h.557v26.248h5.574v48.073H780.4v59.4h-.557v-59.4h-5.572V420.022h5.572Z",
    transform: "translate(-77.92 -48.76)",
    fill: "#c6c6c6",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M759.109,350.508h.557v71.839h5.572v34.81h-5.572v27.081h-.557V457.157h-5.573v-34.81h5.573Z",
    transform: "translate(-75.856 -44.452)",
    fill: "#c6c6c6",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M738.375,358.026h.557v30.664H744.5v2.492h-5.572V456.66h-.557V391.183H732.8v-2.492h5.572Z",
    transform: "translate(-73.792 -45.201)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M717.643,258.462h.556v72.661h5.574v43.1H718.2v17.957h-.556V374.225h-5.575v-43.1h5.575Z",
    transform: "translate(-71.728 -35.289)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M696.911,274.113h.558v69.761h5.572v20.721h-5.572V387.94h-.558V364.595h-5.574V343.874h5.574Z",
    transform: "translate(-69.664 -36.847)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M676.181,86.123h.558V130.6h5.573v4.977h-5.573v84.265h-.558V135.578h-5.573V130.6h5.573Z",
    transform: "translate(-67.601 -18.132)",
    fill: "#c6c6c6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M655.447,48.271h.561V77h5.57v46.416h-5.57v58.576h-.561V123.417h-5.569V77h5.569Z",
    transform: "translate(-65.537 -14.364)",
    fill: "#c6c6c6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M634.717,10.615h.557V79.959h5.574v26.528h-5.574v37.849h-.557V106.488h-5.572V79.959h5.572Z",
    transform: "translate(-63.473 -10.615)",
    fill: "#c6c6c6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M613.986,52.957h.557V85.283h5.575v93.933h-5.575v7.463h-.557v-7.463h-5.572V85.283h5.572Z",
    transform: "translate(-61.409 -14.83)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M593.253,10.615h.557V41h5.572V75.813H593.81v68.524h-.557V75.813h-5.572V41h5.572Z",
    transform: "translate(-59.345 -10.615)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M531.059,354.054h.556V410.97h5.573v54.7h-5.573v22.1h-.556v-22.1h-5.574v-54.7h5.574Z",
    transform: "translate(-53.153 -44.805)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M510.324,275.813h.557v49.45h5.573v72.943h-5.573v11.328h-.557V398.207h-5.572V325.263h5.572Z",
    transform: "translate(-51.089 -37.016)",
    fill: "#c6c6c6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M489.594,261.085h.557v14.649h5.572v38.118h-5.572V394.8h-.557v-80.95h-5.576V275.734h5.576Z",
    transform: "translate(-49.025 -35.55)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M468.859,173.643h.556v89.233h5.575v3.32h-5.575V307.36h-.556V266.2h-5.573v-3.32h5.573Z",
    transform: "translate(-46.961 -26.845)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M448.128,355.347h.556v40.062h5.574v12.15h-5.574v81.5h-.556v-81.5h-5.572v-12.15h5.572Z",
    transform: "translate(-44.898 -44.934)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M427.4,407.814h.558v37.852h5.572v28.177h-5.572v67.688H427.4V473.842h-5.571V445.666H427.4Z",
    transform: "translate(-42.834 -50.157)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M406.664,407.814h.558V463.9h5.571V511.97h-5.571v29.561h-.558V511.97h-5.572V463.9h5.572Z",
    transform: "translate(-40.77 -50.157)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M427.4,10.615h.559V71.4h5.572V83.553h-5.572v60.784H427.4V83.553h-5.571V71.4H427.4Z",
    transform: "translate(-42.834 -10.615)",
    fill: "#c6c6c6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M406.665,33.629h.559V85.57H412.8v29.835h-5.571V167.35h-.559V115.405h-5.572V85.57h5.572Z",
    transform: "translate(-40.77 -12.906)",
    fill: "#c6c6c6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M385.932,10.615h.559v46.14h5.571v4.974h-5.571v82.608h-.559V61.729H380.36V56.756h5.572Z",
    transform: "translate(-38.706 -10.615)",
    fill: "#c6c6c6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M365.2,211.614h.56v29.147h5.57V261.48h-5.57v83.855h-.56V261.48h-5.571V240.761H365.2Z",
    transform: "translate(-36.642 -30.625)",
    fill: "#c6c6c6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M344.468,212.48h.557v30.395H350.6v41.437h-5.574V346.2h-.557V284.312H338.9V242.875h5.572Z",
    transform: "translate(-34.578 -30.711)",
    fill: "#c6c6c6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M323.735,130.458h.56v48.628h5.572v72.938h-5.572v12.158h-.56V252.024h-5.57V179.086h5.57Z",
    transform: "translate(-32.514 -22.546)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M303,129.942h.56v60.781h5.571v12.153h-5.571v60.782H303V202.876h-5.572V190.723H303Z",
    transform: "translate(-30.45 -22.495)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M282.271,46.633h.56V87.8H288.4v3.315h-5.571v89.242h-.56V91.116H276.7V87.8h5.572Z",
    transform: "translate(-28.386 -14.201)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M255.289,44.152h.559v56.914h5.572V132.56h-5.572v45.309h-.559V132.56h-5.572V101.066h5.572Z",
    transform: "translate(-25.7 -13.954)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M234.559,127.413h.557v30.111h5.572v12.158h-5.572v91.445h-.557V169.683h-5.572V157.524h5.572Z",
    transform: "translate(-23.636 -22.243)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M213.825,135.7h.559v37.014h5.572v38.13h-5.572v58.572h-.559V210.843h-5.571v-38.13h5.571Z",
    transform: "translate(-21.572 -23.068)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M193.094,373.458h.558v80.126h5.572v31.5h-5.572v22.093h-.558V485.081h-5.572v-31.5h5.572Z",
    transform: "translate(-19.508 -46.737)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M172.362,110.842h.558V220.529h5.571v12.155H172.92v11.878h-.558V232.685H166.79V220.529h5.572Z",
    transform: "translate(-17.444 -20.593)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M151.63,346.768h.557V378.4h5.572v20.713h-5.572v81.373h-.557V399.115h-5.572V378.4h5.572Z",
    transform: "translate(-15.38 -44.08)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M130.9,256.555h.56v73.5h5.572v41.437h-5.572v18.788h-.56V371.489h-5.571V330.052H130.9Z",
    transform: "translate(-13.316 -35.099)",
    fill: "#c6c6c6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M110.164,211.454h.559v82.609H116.3v24.863h-5.572v26.247h-.559V318.926h-5.571V294.063h5.571Z",
    transform: "translate(-11.252 -30.609)",
    fill: "#c6c6c6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M89.433,250.779h.559v96.7h5.572v4.979H89.992v32.042h-.559V352.453H83.861v-4.979h5.572Z",
    transform: "translate(30.812 -50.524)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M68.7,245.529h.557v40.337h5.573V337.26H69.259v41.993H68.7V337.26H63.128V285.866H68.7Z",
    transform: "translate(32.876 -50.001)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M47.969,286.953h.559v35.365H54.1v24.859H48.528v73.488h-.559V347.178H42.4V322.319h5.572Z",
    transform: "translate(34.94 -54.125)",
    fill: "#c6c6c6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13131",
    "data-name": "Group 13131",
    transform: "translate(337.206 -12.79)",
    opacity: 0.8,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M-75.205,325.283h-1.378v50.278h-7.582V417.9h7.582v50.279h1.378V417.9h7.581V375.561h-7.581Z",
    transform: "translate(84.165 -63.119)",
    fill: "#b2b2b2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M-56.449,343.428h-1.378V366.1H-65.41v19.086h7.583v22.667h1.378V385.182h7.581V366.1h-7.581Z",
    transform: "translate(87.462 -59.93)",
    fill: "#b2b2b2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M-37.694,356.933h-1.379v30.886h-7.581v26.006h7.581v30.888h1.379V413.825h7.581V387.819h-7.581Z",
    transform: "translate(90.759 -57.556)",
    fill: "#b2b2b2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M-18.938,347.029h-1.378v19.686H-27.9V383.3h7.583V402.98h1.378V383.3h7.581v-16.58h-7.581Z",
    transform: "translate(94.056 -59.296)",
    fill: "#b2b2b2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M-.182,260.969H-1.561v56.1H-9.143v83.473h7.582v56.1H-.182v-56.1H7.4V317.069H-.182Z",
    transform: "translate(97.353 -74.425)",
    fill: "#b2b2b2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M18.573,354.848H17.194v27.125H9.613v10.171h7.581v66.362h1.379V392.143h7.582V381.972H18.573Z",
    transform: "translate(100.65 -57.922)",
    fill: "#b2b2b2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M37.33,289.066H35.951V390.331H28.369v16.581h7.582v25.052H37.33V406.912h7.581V390.331H37.33Z",
    transform: "translate(103.947 -69.486)",
    fill: "#b2b2b2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M56.085,343.081H54.706v10.055H47.125v42.341h7.581v90.5h1.379v-90.5h7.582V353.136H56.085Z",
    transform: "translate(107.245 -59.99)",
    fill: "#b2b2b2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M74.841,307.072H73.463v78.842H65.881V405h7.582v44.969h1.378V405h7.582V385.915H74.841Z",
    transform: "translate(110.542 -66.321)",
    fill: "#b2b2b2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M93.6,313.4H92.217V364.81H84.637v70.844h7.581v20.639H93.6V435.654h7.582V364.81H93.6Z",
    transform: "translate(113.839 -65.208)",
    fill: "#b2b2b2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M112.352,269.932h-1.379V383.721h-7.581v14.818h7.581v14.289h1.379V398.539h7.582V383.721h-7.582Z",
    transform: "translate(117.136 -72.849)",
    fill: "#b2b2b2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M131.107,260.93h-1.378v50.881h-7.581v88.311h7.581v3.705h1.378v-3.705h7.582V311.811h-7.582Z",
    transform: "translate(120.433 -74.432)",
    fill: "#b2b2b2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M149.864,250.386h-1.379v88.563H140.9V368.41h7.581v24.874h1.379V368.41h7.581V338.949h-7.581Z",
    transform: "translate(123.73 -76.285)",
    fill: "#b2b2b2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M168.619,293.6h-1.378v52.483H159.66v14.733h7.581V436.5h1.378V360.814H176.2V346.081h-7.582Z",
    transform: "translate(127.027 -68.689)",
    fill: "#b2b2b2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M187.375,306.818H186v57.687h-7.581v7.408H186v77.8h1.378v-77.8h7.582v-7.408h-7.582Z",
    transform: "translate(130.324 -66.365)",
    fill: "#b2b2b2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M206.13,283.412h-1.378v24.874h-7.582v67.743h7.582V426.31h1.378V376.029h7.581V308.285H206.13Z",
    transform: "translate(133.621 -70.48)",
    fill: "#b2b2b2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M224.886,209.056h-1.378V311.2h-7.581v7.411h7.581v33.342h1.378V318.611h7.582V311.2h-7.582Z",
    transform: "translate(136.918 -83.551)",
    fill: "#b2b2b2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M243.642,257.668h-1.378v31.226h-7.582v21.171h7.582v90.5h1.378v-90.5h7.581V288.894h-7.581Z",
    transform: "translate(140.215 -75.005)",
    fill: "#b2b2b2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M262.4,261.269H261.02v5.822h-7.582V374.073h7.582v30.1H262.4v-30.1h7.582V267.092H262.4Z",
    transform: "translate(143.512 -74.372)",
    fill: "#b2b2b2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M281.154,192.851h-1.379V300.288h-7.581v21.171h7.581v14.29h1.379v-14.29h7.581V300.288h-7.581Z",
    transform: "translate(146.81 -86.399)",
    fill: "#b2b2b2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M299.91,158.427h-1.378v47.927h-7.583v15.57h7.583v12.029h1.378V221.923h7.581v-15.57H299.91Z",
    transform: "translate(150.106 -92.451)",
    fill: "#b2b2b2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M318.666,183.169h-1.379v34.4h-7.582v8.673h7.582v32.447h1.379V226.247h7.581v-8.673h-7.581Z",
    transform: "translate(153.404 -88.101)",
    fill: "#b2b2b2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M337.422,211.717h-1.378v35.8h-7.583v35.525h7.583v4.2h1.378v-4.2H345V247.522h-7.581Z",
    transform: "translate(156.701 -83.083)",
    fill: "#b2b2b2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M356.178,218.378H354.8V277.96h-7.582v3.916H354.8V293.9h1.379V281.876h7.581V277.96h-7.581Z",
    transform: "translate(159.998 -81.912)",
    fill: "#b2b2b2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M374.933,196.491h-1.379v59.062h-7.582v4.4h7.582v12.069h1.379V259.949h7.581v-4.4h-7.581Z",
    transform: "translate(163.295 -85.76)",
    fill: "#b2b2b2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M393.688,226.942H392.31v21.074h-7.582v8.763h7.582v45.688h1.378V256.779h7.582v-8.763h-7.582Z",
    transform: "translate(166.592 -80.407)",
    fill: "#b2b2b2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M412.445,229.8h-1.379v46.852h-7.582V289.8h7.582v15.524h1.379V289.8h7.581V276.651h-7.581Z",
    transform: "translate(169.889 -79.905)",
    fill: "#b2b2b2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M431.2,257.394h-1.378v32.719H422.24V300.2h7.581v32.716H431.2V300.2h7.582V290.113H431.2Z",
    transform: "translate(173.186 -75.053)",
    fill: "#b2b2b2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M449.954,271.668h-1.378v35.565H441v4.4h7.581V347.2h1.378V311.629h7.583v-4.4h-7.583Z",
    transform: "translate(176.483 -72.544)",
    fill: "#b2b2b2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M468.71,246.927h-1.379v41.259h-7.579v13.146h7.579v21.121h1.379V301.332h7.583V288.186H468.71Z",
    transform: "translate(179.78 -76.894)",
    fill: "#b2b2b2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M487.468,219.331h-1.379v34.4h-7.582v6.714h7.582v34.406h1.379V260.449h7.581v-6.714h-7.581Z",
    transform: "translate(183.077 -81.745)",
    fill: "#b2b2b2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M506.222,177.46h-1.378v48.382h-7.581V235.93h7.581v17.054h1.378V235.93H513.8V225.842h-7.582Z",
    transform: "translate(186.375 -89.105)",
    fill: "#b2b2b2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M524.978,199.346H523.6v23.5h-7.58v34.4h7.58v17.623h1.379V257.248h7.582v-34.4h-7.582Z",
    transform: "translate(189.672 -85.258)",
    fill: "#b2b2b2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M543.734,172.7h-1.379v34.545h-7.58v17.762h7.58v23.217h1.379V225.009h7.581V207.247h-7.581Z",
    transform: "translate(192.969 -89.942)",
    fill: "#b2b2b2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M562.489,175.556h-1.378V202.13H553.53v34.406h7.581v14.546h1.378V236.536h7.583V202.13h-7.583Z",
    transform: "translate(196.266 -89.44)",
    fill: "#b2b2b2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M581.245,152.717h-1.377V180.69h-7.582v38.882h7.582v8.671h1.377v-8.671h7.583V180.69h-7.583Z",
    transform: "translate(199.563 -93.455)",
    fill: "#b2b2b2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M600,209.814h-1.379v22.1h-7.581v8.951h7.581v44.476H600V240.863h7.582v-8.951H600Z",
    transform: "translate(202.86 -83.418)",
    fill: "#b2b2b2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M618.757,226.942h-1.379v34.912H609.8v14.653h7.579v25.96h1.379v-25.96h7.58V261.854h-7.58Z",
    transform: "translate(206.157 -80.407)",
    fill: "#b2b2b2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M637.512,242.169h-1.378v33.98h-7.581v32.874h7.581v8.67h1.378v-8.67h7.582V276.148h-7.582Z",
    transform: "translate(209.454 -77.73)",
    fill: "#b2b2b2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M656.268,257.394h-1.379V292.96h-7.58v4.394h7.58v35.564h1.379V297.354h7.582V292.96h-7.582Z",
    transform: "translate(212.751 -75.053)",
    fill: "#b2b2b2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M675.024,221.233h-1.379v23.312h-7.581v8.763h7.581V296.76h1.379V253.308h7.583v-8.763h-7.583Z",
    transform: "translate(216.048 -81.41)",
    fill: "#b2b2b2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M693.779,186.975H692.4v43.972H684.82v7.724H692.4V262.5h1.377V238.67h7.583v-7.724h-7.583Z",
    transform: "translate(219.345 -87.433)",
    fill: "#b2b2b2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M712.536,202.2h-1.378v7.552h-7.582v29.039h7.582v38.935h1.378V238.792h7.582V209.753h-7.582Z",
    transform: "translate(222.642 -84.756)",
    fill: "#b2b2b2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M731.291,182.217h-1.379V242.3h-7.58v9.843h7.58v5.595h1.379v-5.595h7.582V242.3h-7.582Z",
    transform: "translate(225.94 -88.269)",
    fill: "#b2b2b2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M750.046,165.4h-1.378v14.306h-7.581V222.1h7.581v86.366h1.378V222.1h7.582V179.711h-7.582Z",
    transform: "translate(229.237 -91.224)",
    fill: "#b2b2b2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M768.8,134.761h-1.378v85.411h-7.581V234.8h7.581v43.021H768.8V234.8h7.583V220.172H768.8Z",
    transform: "translate(232.534 -96.611)",
    fill: "#b2b2b2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M787.558,102.315h-1.377v68.6H778.6v68.1h7.582v6.358h1.377v-6.358h7.583v-68.1h-7.583Z",
    transform: "translate(235.831 -102.315)",
    fill: "#b2b2b2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M806.315,134.761h-1.379v67.367h-7.582v8.329h7.582v67.366h1.379V210.457H813.9v-8.329h-7.582Z",
    transform: "translate(239.128 -96.611)",
    fill: "#b2b2b2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M825.07,194.246h-1.378v56.7H816.11v65.7h7.582v20.667h1.378V316.641h7.582v-65.7H825.07Z",
    transform: "translate(242.425 -86.154)",
    fill: "#b2b2b2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M843.826,245.976h-1.378v24.39h-7.581v13.318h7.581V321.5h1.378V283.684h7.582V270.365h-7.582Z",
    transform: "translate(245.722 -77.061)",
    fill: "#b2b2b2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M862.581,204.363H861.2v38.73h-7.579v24.528H861.2V343.44h1.379V267.621h7.582V243.093h-7.582Z",
    transform: "translate(249.019 -84.376)",
    fill: "#b2b2b2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M881.337,176.325h-1.379v48.934h-7.581v27.916h7.581V315.4h1.379V253.175h7.582V225.259h-7.582Z",
    transform: "translate(252.316 -89.305)",
    fill: "#b2b2b2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M900.092,158.8h-1.377v92.3h-7.582v24.528h7.582v22.248h1.377V275.631h7.583V251.1h-7.583Z",
    transform: "translate(255.613 -92.385)",
    fill: "#b2b2b2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M926.431,198.094h-7.582V130.764h-1.378v67.329H909.89v19.329h7.582v52.419h1.378V217.422h7.582Z",
    transform: "translate(258.91 -97.314)",
    fill: "#b2b2b2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachingSessionBg);
export default __webpack_public_path__ + "static/media/coachingSessionBG.04879e72685e4fb20b3445762d6f095e.svg";
export { ForwardRef as ReactComponent };